import type { ScrollViewProps } from "react-native"
import { Platform } from "react-native"

export const HEADER_LARGE_CHILD_SCROLL_ADJUSTMENT: ScrollViewProps["contentInsetAdjustmentBehavior"] =
  Platform.select({
    default: undefined,
    ios: "automatic",
  })

export const HEADER_LARGE_SCROLL_CHILD_PROPS = {
  contentAdjustmentBehavior: HEADER_LARGE_CHILD_SCROLL_ADJUSTMENT,
}
